import React from "react";
import "@fontsource/inter/600.css";

const OverviewCardShell = ({ title, action, icon, children, className = "" }) => {
  return (
    <section
      className={[
        "rounded-xl min-w-0 bg-white px-4 md:px-6 pt-4 md:pt-6 pb-5 shadow-[0_2px_5.7px_0_#00000026]",
        className,
      ].join(" ")}
    >
      <div className="mb-4 flex items-center min-[1688px]:items-start justify-between gap-3 sm:gap-4">
        <h2 className="sm:text-lg font-['Inter']  font-semibold leading-7 text-[#111827]">{title}</h2>
        <div className="flex items-center gap-2">
          {action ? <div>{action}</div> : null}
          {icon ? <div>{icon}</div> : null}
        </div>
      </div>

      {children}
    </section>
  );
};

export default OverviewCardShell;
